import React, { useLayoutEffect, useState } from 'react';
import { Avatar, Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseRow from '~/components/common/base-row/BaseRow';
import { useCallContext } from '~/context/CallContext';

const CallDeviceModal = () => {
  const { t } = useTranslation('admin/person');
  const {
    isCallDeviceModalOpen,
    isActiveCallVisible,
    callData,
    callStatus,
    isLoading,
    closeAllAndHangup,
    startOutgoingCall,
  } = useCallContext();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  useLayoutEffect(() => {
    if (!isCallDeviceModalOpen) {
      setShowConfirmDialog(false);
      return;
    }
    setShowConfirmDialog(!isActiveCallVisible);
  }, [isCallDeviceModalOpen, isActiveCallVisible]);

  if (!isCallDeviceModalOpen && !showConfirmDialog) {
    return null;
  }

  const canCall = callStatus === 'idle' || callStatus === 'ended';

  return (
    <Dialog open={showConfirmDialog} onClose={closeAllAndHangup} fullWidth maxWidth='sm'>
      <DialogTitle className='bg-white text-xl font-semibold text-[#161A1F] text-center'>{t('call.title')}</DialogTitle>
      <DialogContent>
        <Typography className='text-[#161A1F] font-medium text-sm mb-2 text-center'>
          {t('call.confirm', { name: callData?.display_name })}
        </Typography>
        <Box className='mb-2'>
          <BaseRow className='rounded-xl bg-[#DCE8F5] p-3 gap-4'>
            <Avatar className='rounded-full w-20 h-20 bg-[#D9D9D9]' src={callData?.icon} />
            <Box className='w-full'>
              <Typography
                sx={{
                  fontFamily: '"Manrope", sans-serif',
                  fontSize: 16,
                  fontWeight: 600,
                  lineHeight: '140%',
                  letterSpacing: '0.02em',
                  color: '#161A1F',
                }}
              >
                {callData?.display_name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Manrope", sans-serif',
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: '140%',
                  letterSpacing: '0.02em',
                  color: '#161A1F',
                }}
              >
                {callData?.imei}
              </Typography>
              {callData?.current_address && (
                <Typography
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: '140%',
                    letterSpacing: '0.02em',
                    color: '#161A1F',
                  }}
                >
                  {callData.current_address}
                </Typography>
              )}
            </Box>
          </BaseRow>
        </Box>
        <Box className='flex justify-between gap-3 mt-5'>
          <Button variant='outlined' className='w-full' onClick={closeAllAndHangup} disabled={isLoading}>
            {t('cancel', { ns: 'admin/common' })}
          </Button>
          <Button
            variant='contained'
            className='w-full bg-[#123B6D]'
            onClick={() => void startOutgoingCall()}
              disabled={isLoading || !canCall}
          >
            {isLoading ? t('call.processing') : t('call.button')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CallDeviceModal;
